import { render, staticRenderFns } from "./textbox.vue?vue&type=template&id=465c016b&scoped=true&"
import script from "./textbox.vue?vue&type=script&lang=js&"
export * from "./textbox.vue?vue&type=script&lang=js&"
import style0 from "./textbox.vue?vue&type=style&index=0&id=465c016b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465c016b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('465c016b')) {
      api.createRecord('465c016b', component.options)
    } else {
      api.reload('465c016b', component.options)
    }
    module.hot.accept("./textbox.vue?vue&type=template&id=465c016b&scoped=true&", function () {
      api.rerender('465c016b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/textbox.vue"
export default component.exports